import { callMsToken } from 'pages/auth/new/sso/config';
import { callTcapAdmin } from 'pages/auth/new/sso/config/auth';

export async function callSsoApi(
    accessToken,
    dispatch,
    setLoginData,
    setFormState,
    setErrorMessage,
) {
    try {
        setFormState('pending');
        let tcapLoginData = await callMsToken(accessToken);
        setLoginData(tcapLoginData);

        if (!tcapLoginData.token) {
            setErrorMessage(tcapLoginData);
            setFormState('idle');
            return;
        }

        const adminData = await callTcapAdmin(tcapLoginData.token);

        if (!adminData) {
            setErrorMessage('Failed to load user information');
            setFormState('idle');
            return;
        }

        setFormState('success');
        dispatch({
            type: 'LOGIN_SUCCESS',
            payload: {
                ...tcapLoginData,
                ...adminData, // Includes apiDocReader
                email: tcapLoginData?.user,
                loadAccessList: true,
            },
        });
    } catch (requestErr) {
        console.log('Error sending data to the backend: ', requestErr.message);
        setErrorMessage('Unable to login.');
        setFormState('idle');
        sessionStorage.clear();
    }
}
